import React from "react";
import { View, StyleSheet } from "react-native";
import { colors } from "../../theme";

type Props = {};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.black,
    paddingTop: 15,
    // web/index.html sets viewport-fit=cover, which lets page content
    // extend under the iPhone's home-indicator/dynamic-toolbar zone --
    // without this, iOS Safari's own chrome can visually overlap a
    // button pinned at the naive bottom edge right as it animates in
    // after a scroll, swallowing a tap aimed at the button underneath.
    // @ts-ignore -- env() is a valid web-only CSS value RN's ViewStyle
    // typings don't know about; harmless no-op on native.
    paddingBottom: "calc(15px + env(safe-area-inset-bottom, 0px))",
    paddingHorizontal: 20,
    borderTopColor: colors.darkestGrey,
    borderTopWidth: 1,
  },
});

const StickyFooter: React.FC<Props> = ({ children }) => (
  <View style={styles.container}>{children}</View>
);

export default StickyFooter;
